var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashcam(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "752.000000pt",
    height: "752.000000pt",
    viewBox: "0 0 752.000000 752.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,752.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2823 5525 c-17 -7 -36 -22 -42 -34 -17 -31 -13 -86 8 -112 l19 -24 429 -5 428 -5 0 -200 0 -200 -550 -5 c-545 -5 -550 -5 -599 -28 -105 -48 -178 -130 -215 -240 -21 -61 -21 -75 -21 -1206 0 -1113 1 -1146 20 -1207 35 -112 122 -204 237 -251 l58 -23 1165 0 1165 0 58 23 c116 47 203 139 237 252 20 64 20 90 18 1226 l-3 1160 -38 76 c-43 88 -102 146 -187 187 l-55 26 -550 5 -550 5 0 200 0 200 428 5 429 5 19 24 c21 26 25 81 8 113 -26 49 -16 48 -981 48 -745 -1 -909 -3 -935 -15z m85 -992 c86 -64 86 -192 0 -256 -16 -12 -48 -22 -80 -25 -44 -3 -59 0 -87 20 -57 38 -75 72 -75 133 0 61 18 95 75 133 28 20 43 23 87 20 32 -3 64 -13 80 -25z m1077 -193 c271 -70 507 -275 611 -531 63 -155 83 -367 50 -526 -70 -333 -308 -588 -643 -690 -78 -23 -105 -26 -238 -27 -113 0 -166 4 -213 17 -325 88 -548 296 -653 607 -28 83 -33 112 -37 229 -5 153 6 237 49 355 108 299 372 521 687 581 104 20 282 13 387 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3619 4165 c-361 -72 -610 -415 -568 -783 40 -356 349 -632 709 -632 360 0 669 276 709 632 54 481 -376 877 -850 783z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashcam);
export default __webpack_public_path__ + "static/media/dashcam.87fa74f163eeaf48b56fec42bbe5a3b6.svg";
export { ForwardRef as ReactComponent };